export default __webpack_public_path__ + "static/media/review-checkout-icon.58fc9817.svg";